import { useState } from "react";

import { cx } from "@/utils";

import Fallback from "./Fallback";

import styles from "../Cover.module.css";

const GenericCover = ({ episode }) => {
  const { cover, source } = episode;
  const [imgLoadFailed, setImgLoadFailed] = useState(false);
  const [coverLoaded, setCoverLoaded] = useState(false);

  return imgLoadFailed || !cover ? (
    <Fallback source={source} />
  ) : (
    <img
      loading="lazy"
      src={cover}
      className={cx(styles.img, { [styles.visible]: coverLoaded })}
      onLoad={() => setCoverLoaded(true)}
      onError={() => setImgLoadFailed(true)}
      alt=""
    />
  );
};
export default GenericCover;
